import { Injectable } from '@angular/core';

interface MessagesForm {
  subject: string | null | undefined;
  body: string | null | undefined;
  template?: string | null | undefined;
  hashtags: any;
  senderId: string;
}

export interface SavedMessages extends MessagesForm {
  id: string;
}

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  messages: MessagesForm = {
    subject: '',
    body: '',
    template: '',
    hashtags: [],
    senderId: '',
  };

  savedMessages: SavedMessages[] = [];

  constructor() {}

  getHashtag(hashtag: string) {
    this.messages.hashtags.push(hashtag);
  }

  removeHashtag(index: number) {
    this.messages.hashtags.splice(index, 1);
  }

  deleteSavedMessage(id: string) {
    const index = this.savedMessages.findIndex((item) => item.id === id);
    this.savedMessages.splice(index, 1);
  }

  reset() {
    this.messages = {
      subject: '',
      body: '',
      template: '',
      hashtags: [],
      senderId: '',
    };
  }

  resetSavedMessages() {
    this.savedMessages = [];
  }
}
